const local_config = {
  // serverUrl: 'https://api-video-staging.myinterview.com',
  serverUrl: 'https://api-video-dev.myinterview.com', // TODO: change it back when vius merged to staging
  INTERCOM_APP_ID: 'w75vea5o',
  SENTRY_DSN: 'https://a49d1d55605640f4890f9534766f0ea8@o79324.ingest.sentry.io/6579209',
};

export default local_config;
